import { render } from "./restaurantselector.vue?vue&type=template&id=1fa0f9e0"
import script from "./restaurantselector.vue?vue&type=script&lang=js"
export * from "./restaurantselector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__